export function GoogleIcon() {
	return (
		<svg width='20' height='20' viewBox='0 0 20 20' fill='none' aria-hidden>
			<path
				d='M18.8 10.2273C18.8 9.51819 18.7364 8.83637 18.6182 8.18182H10.2V12.05H15.0091C14.7727 13.3 14.0727 14.3591 13.0182 15.0682V17.5773H16.3091C18.1091 15.8364 19.2 13.2727 19.2 10.2273H18.8Z'
				fill='#4285F4'
			/>
			<path
				d='M10.2 20C12.9 20 15.1727 19.1091 16.3091 17.5773L13.0182 15.0682C12.1091 15.6682 10.8909 16.0227 10.2 16.0227C7.89091 16.0227 5.90909 14.4182 5.21818 12.3H1.81818V14.8818C2.94545 17.7091 6.30909 20 10.2 20Z'
				fill='#34A853'
			/>
			<path
				d='M5.21818 12.3C5.01818 11.7 4.90909 11.05 4.90909 10.3636C4.90909 9.67727 5.01818 9.03182 5.21818 8.43182V5.85H1.81818C1.10909 7.25909 0.727273 8.76818 0.727273 10.3636C0.727273 11.9591 1.10909 13.4682 1.81818 14.8773L5.21818 12.3Z'
				fill='#FBBC05'
			/>
			<path
				d='M10.2 4.70455C11.0091 4.70455 11.7364 4.97727 12.3091 5.50455L15.1727 2.64091C13.8636 1.44091 12.1364 0.727273 10.2 0.727273C6.30909 0.727273 2.94545 3.01818 1.81818 5.84545L5.21818 8.42727C5.90909 6.30909 7.89091 4.70455 10.2 4.70455Z'
				fill='#EA4335'
			/>
		</svg>
	)
}

export function MetaMaskIcon() {
	return (
		<svg width='20' height='20' viewBox='0 0 318.6 318.6' fill='none' aria-hidden>
			<path fill='#E2761B' stroke='#E2761B' strokeLinecap='round' strokeLinejoin='round' d='m274.1 35.5-99.5 73.9L193 65.8z' />
			<path
				fill='#E4761B'
				stroke='#E4761B'
				strokeLinecap='round'
				strokeLinejoin='round'
				d='m44.4 35.5 98.7 74.6-17.5-44.3zm193.9 171.3-26.5 40.6 56.7 15.6 16.3-55.3zm-204.4.9L50.1 263l56.7-15.6-26.5-40.6z'
			/>
			<path
				fill='#E4761B'
				stroke='#E4761B'
				strokeLinecap='round'
				strokeLinejoin='round'
				d='m103.6 138.2-15.8 23.9 56.3 2.5-2-60.5zm111.3 0-39-34.8-1.3 61.2 56.2-2.5zM106.8 247.4l33.8-16.5-29.2-22.8zm71.1-16.5 33.9 16.5-4.7-39.3z'
			/>
			<path fill='#D7C1B3' stroke='#D7C1B3' strokeLinecap='round' strokeLinejoin='round' d='m211.8 247.4-33.9-16.5 2.7 22.1-.3 9.3zm-105 0 31.5 14.9-.2-9.3 2.5-22.1z' />
			<path fill='#233447' stroke='#233447' strokeLinecap='round' strokeLinejoin='round' d='m138.8 193.5-28.2-8.3 19.9-9.1zm40.9 0 8.3-17.4 20 9.1z' />
			<path
				fill='#CD6116'
				stroke='#CD6116'
				strokeLinecap='round'
				strokeLinejoin='round'
				d='m106.8 247.4 4.8-40.6-31.3.9zM207 206.8l4.8 40.6 26.5-39.7zm23.8-44.7-56.2 2.5 5.2 28.9 8.3-17.4 20 9.1zm-120.2 23.1 20-9.1 8.2 17.4 5.3-28.9-56.3-2.5z'
			/>
			<path
				fill='#E4751F'
				stroke='#E4751F'
				strokeLinecap='round'
				strokeLinejoin='round'
				d='m87.8 162.1 23.6 46-.8-22.9zm120.3 23.1-1 22.9 23.7-46zm-64-20.6-5.3 28.9 6.6 34.1 1.5-44.9zm30.5 0-2.7 18 1.2 45 6.7-34.1z'
			/>
			<path
				fill='#F6851B'
				stroke='#F6851B'
				strokeLinecap='round'
				strokeLinejoin='round'
				d='m179.8 193.5-6.7 34.1 4.8 3.3 29.2-22.8 1-22.9zm-69.2-8.3.8 22.9 29.2 22.8 4.8-3.3-6.6-34.1z'
			/>
			<path
				fill='#C0AD9E'
				stroke='#C0AD9E'
				strokeLinecap='round'
				strokeLinejoin='round'
				d='m180.3 262.3.3-9.3-2.5-2.2h-37.7l-2.3 2.2.2 9.3-31.5-14.9 11 9 22.3 15.5h38.3l22.4-15.5 11-9z'
			/>
			<path fill='#161616' stroke='#161616' strokeLinecap='round' strokeLinejoin='round' d='m177.9 230.9-4.8-3.3h-27.7l-4.8 3.3-2.5 22.1 2.3-2.2h37.7l2.5 2.2z' />
			<path
				fill='#763D16'
				stroke='#763D16'
				strokeLinecap='round'
				strokeLinejoin='round'
				d='m278.3 114.2 8.5-40.8-12.7-37.9-96.2 71.4 37 31.3 52.3 15.3 11.6-13.5-5-3.6 8-7.3-6.2-4.8 8-6.1zM31.8 73.4l8.5 40.8-5.4 4 8 6.1-6.1 4.8 8 7.3-5 3.6 11.5 13.5 52.3-15.3 37-31.3-96.2-71.4z'
			/>
			<path
				fill='#F6851B'
				stroke='#F6851B'
				strokeLinecap='round'
				strokeLinejoin='round'
				d='m267.2 153.5-52.3-15.3 15.9 23.9-23.7 46 31.2-.4h46.5zm-163.6-15.3-52.3 15.3-17.4 54.2h46.4l31.1.4-23.6-46zm71 26.4 3.3-57.7 15.2-41.1h-67.5l15 41.1 3.5 57.7 1.2 18.2.1 44.8h27.7l.2-44.8z'
			/>
		</svg>
	)
}
